module.exports = (__parcel__import__("dyUE0")).then(() => parcelRequire('fyWP3'));